import brand_logo_large from "../assets/wog-logo-new.svg";
import brand_logo_small from "../assets/wog_logo_small.svg";
import tabIcon from "../assets/appicon/appIcon-WOG@512.png";
import newsCover from "@/assets/cover/news_wog.webp";

export const WOG_brandVariables = {
  siteTitle: "WoG",
  siteIcon: tabIcon,
  name: "World of Gamers",
  name_small: "WOG",
  logos: {
    large: brand_logo_large,
    white: brand_logo_large,
    small: brand_logo_small,
    medium: brand_logo_large,
    alt_text: "World of Gamers logo",
    profile: brand_logo_large,
  },
  cover: {
    news: newsCover,
  },
  tenantId: "spike-dbg8t",
  brandTheme: "wog", // Theme of the brand
  site: "", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone
  defaultCountryCode: "DK", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "en",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "WOG", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: false,
  subClientsForOverviews: null, // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: false,
  hasFeature: {
    notifications: true,
    themes: false,
    connections: false,
    achievements: false,
    messages: false,
    teams: true,
    news: true,
    challenges: true,
    singleChallenge: true,
    preferences: false,
    friends: true,
    zones: false,
    feed: true,
    posts: false,
    winners: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    schedule: false, // !! Also add the data variables for this feature in brandVariables.tsx !!
    qrSignUp: false,
    manualSubmissions: true,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: true,
    hero: true,
    search: true,
    routes: false,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
    changePassword: true,
    feedback: false,
    events: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: true,
    discord: true,
    twitch: false,
  },
  layout: {
    challenge: "default",
  },
  event: {
    forcedCredentialPopup: "email",
    eventCode: "", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: false,
    spacecoins_redirect: true,
  },
  hasCreate: {
    challenges: true,
  },
};
